<template>
    <div>
      {{ dateItem | formattedDate }}
    </div>
</template>

<script>

export default {
  props: {
    dateItem: String
  }
}
</script>
